// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FundraiserListing_container__UmEPj{
    display: flex;
    align-items: center;
    flex-direction: column;
    width: 257px;
    padding: 24px 24px 32px 24px;
    border: 1px solid #1F363D1A;
    border-radius: 25px;
    text-decoration: none;
    box-shadow: 0 3px 12px 0 #00000012;
}
.FundraiserListing_name__SOZVr{
    max-width: 100%;
    margin-top: 0;
    margin-bottom: 8px;
    text-align: center;
    color: #40798C;
    font-size: 16px;
    font-family: 'Gotham Bold', serif;
    line-height: 16px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}
.FundraiserListing_status__MCrOV{
    margin-bottom: 10px;
    padding: 6px 12px;
    font-size: 12px;
    font-family: 'Gotham Medium', serif;
    border: 1px solid;
    border-radius: 14px;
}
.FundraiserListing_organization__8rxTv{
    display: flex;
    height: 42px;
    width: 100%;
    margin-top: 18px;
}
.FundraiserListing_organizationLabel__ElNXM{
    margin-right: 5px;
    color: #1F363D80;
    text-align: left;
    font-size: 14px;
}
.FundraiserListing_organizationName__PQhYN{
    display: inline-block;
    position: relative;
    top: 0.5px;
    max-width: calc(100% - 70px);
    margin-left: auto;
    color: #1F363D;
    font-size: 14px;
    font-family: 'Gotham Medium', serif;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}
.FundraiserListing_organizationPicture__UZ1IA{
    position: relative;
    top: -10px;
    height: 40px;
    width: 40px;
    margin-left: 7px;
    border-radius: 500px;
}
.FundraiserListing_description__B3Vy5{
    display: -webkit-box;
    height: 51px;
    color: #1F363D;
    line-height: 16px;
    font-size: 12px;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow-y: hidden;
}
.FundraiserListing_notStarted__buiMy{
    color: #40798C;
    background-color: #ECF2F4;
    border-color: #DBE6EA;
}
.FundraiserListing_inProgress__hTBhx{
    color: #9C7A00;
    background-color: #FFD952;
    border-color: #EECB4E;
}
.FundraiserListing_ended__VmI1Y{
    color: #396D51;
    background-color: #9DD1A8;
    border-color: #9AC2A0;
}
.FundraiserListing_label__0vdAx{
    display: block;
    color: #1F363D80;
    text-align: center;
    font-size: 14px;
}
.FundraiserListing_value__55eWA{
    color: #1F363D;
    font-size: 14px;
    font-family: 'Gotham Medium', serif;
}
.FundraiserListing_progress__gGjoB{
    display: flex;
    align-items: center;
    flex-direction: column;
    width: 100%;
    margin-top: 10px;
}
.FundraiserListing_progressBar__JXqXn{
    height: 8px;
    width: 90%;
    margin-top: 8px;
    background-color: #ECECEC;
    border-radius: 500px;
}
.FundraiserListing_progressMade__uasW-{
    height: 100%;
    width: 100%;
    background: linear-gradient(90deg, #BC4749 0%, #FFEC41 49%, #A7C957 100%);
    border-radius: 500px;
}
.FundraiserListing_firstInfoRow__OhGpO{
    display: flex;
    width: 100%;
    margin-top: 20px;
}
.FundraiserListing_startAt__4u74N{

}
.FundraiserListing_endAt__G\\+4aM{
    margin-left: auto;
}
.FundraiserListing_secondInfoRow__iFreH{
    margin-top: 20px;
}
.FundraiserListing_totalDonations__H\\+m5m{
    text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/components/FundraiserListing.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,YAAY;IACZ,4BAA4B;IAC5B,2BAA2B;IAC3B,mBAAmB;IACnB,qBAAqB;IACrB,kCAAkC;AACtC;AACA;IACI,eAAe;IACf,aAAa;IACb,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,iCAAiC;IACjC,iBAAiB;IACjB,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;AACpB;AACA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,mCAAmC;IACnC,iBAAiB;IACjB,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,YAAY;IACZ,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,UAAU;IACV,4BAA4B;IAC5B,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,mCAAmC;IACnC,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,oBAAoB;AACxB;AACA;IACI,oBAAoB;IACpB,YAAY;IACZ,cAAc;IACd,iBAAiB;IACjB,eAAe;IACf,qBAAqB;IACrB,4BAA4B;IAC5B,kBAAkB;AACtB;AACA;IACI,cAAc;IACd,yBAAyB;IACzB,qBAAqB;AACzB;AACA;IACI,cAAc;IACd,yBAAyB;IACzB,qBAAqB;AACzB;AACA;IACI,cAAc;IACd,yBAAyB;IACzB,qBAAqB;AACzB;AACA;IACI,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,cAAc;IACd,eAAe;IACf,mCAAmC;AACvC;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,UAAU;IACV,eAAe;IACf,yBAAyB;IACzB,oBAAoB;AACxB;AACA;IACI,YAAY;IACZ,WAAW;IACX,yEAAyE;IACzE,oBAAoB;AACxB;AACA;IACI,aAAa;IACb,WAAW;IACX,gBAAgB;AACpB;AACA;;AAEA;AACA;IACI,iBAAiB;AACrB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,kBAAkB;AACtB","sourcesContent":[".container{\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    width: 257px;\n    padding: 24px 24px 32px 24px;\n    border: 1px solid #1F363D1A;\n    border-radius: 25px;\n    text-decoration: none;\n    box-shadow: 0 3px 12px 0 #00000012;\n}\n.name{\n    max-width: 100%;\n    margin-top: 0;\n    margin-bottom: 8px;\n    text-align: center;\n    color: #40798C;\n    font-size: 16px;\n    font-family: 'Gotham Bold', serif;\n    line-height: 16px;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    overflow: hidden;\n}\n.status{\n    margin-bottom: 10px;\n    padding: 6px 12px;\n    font-size: 12px;\n    font-family: 'Gotham Medium', serif;\n    border: 1px solid;\n    border-radius: 14px;\n}\n.organization{\n    display: flex;\n    height: 42px;\n    width: 100%;\n    margin-top: 18px;\n}\n.organizationLabel{\n    margin-right: 5px;\n    color: #1F363D80;\n    text-align: left;\n    font-size: 14px;\n}\n.organizationName{\n    display: inline-block;\n    position: relative;\n    top: 0.5px;\n    max-width: calc(100% - 70px);\n    margin-left: auto;\n    color: #1F363D;\n    font-size: 14px;\n    font-family: 'Gotham Medium', serif;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    overflow: hidden;\n}\n.organizationPicture{\n    position: relative;\n    top: -10px;\n    height: 40px;\n    width: 40px;\n    margin-left: 7px;\n    border-radius: 500px;\n}\n.description{\n    display: -webkit-box;\n    height: 51px;\n    color: #1F363D;\n    line-height: 16px;\n    font-size: 12px;\n    -webkit-line-clamp: 3;\n    -webkit-box-orient: vertical;\n    overflow-y: hidden;\n}\n.notStarted{\n    color: #40798C;\n    background-color: #ECF2F4;\n    border-color: #DBE6EA;\n}\n.inProgress{\n    color: #9C7A00;\n    background-color: #FFD952;\n    border-color: #EECB4E;\n}\n.ended{\n    color: #396D51;\n    background-color: #9DD1A8;\n    border-color: #9AC2A0;\n}\n.label{\n    display: block;\n    color: #1F363D80;\n    text-align: center;\n    font-size: 14px;\n}\n.value{\n    color: #1F363D;\n    font-size: 14px;\n    font-family: 'Gotham Medium', serif;\n}\n.progress{\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    width: 100%;\n    margin-top: 10px;\n}\n.progressBar{\n    height: 8px;\n    width: 90%;\n    margin-top: 8px;\n    background-color: #ECECEC;\n    border-radius: 500px;\n}\n.progressMade{\n    height: 100%;\n    width: 100%;\n    background: linear-gradient(90deg, #BC4749 0%, #FFEC41 49%, #A7C957 100%);\n    border-radius: 500px;\n}\n.firstInfoRow{\n    display: flex;\n    width: 100%;\n    margin-top: 20px;\n}\n.startAt{\n\n}\n.endAt{\n    margin-left: auto;\n}\n.secondInfoRow{\n    margin-top: 20px;\n}\n.totalDonations{\n    text-align: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `FundraiserListing_container__UmEPj`,
	"name": `FundraiserListing_name__SOZVr`,
	"status": `FundraiserListing_status__MCrOV`,
	"organization": `FundraiserListing_organization__8rxTv`,
	"organizationLabel": `FundraiserListing_organizationLabel__ElNXM`,
	"organizationName": `FundraiserListing_organizationName__PQhYN`,
	"organizationPicture": `FundraiserListing_organizationPicture__UZ1IA`,
	"description": `FundraiserListing_description__B3Vy5`,
	"notStarted": `FundraiserListing_notStarted__buiMy`,
	"inProgress": `FundraiserListing_inProgress__hTBhx`,
	"ended": `FundraiserListing_ended__VmI1Y`,
	"label": `FundraiserListing_label__0vdAx`,
	"value": `FundraiserListing_value__55eWA`,
	"progress": `FundraiserListing_progress__gGjoB`,
	"progressBar": `FundraiserListing_progressBar__JXqXn`,
	"progressMade": `FundraiserListing_progressMade__uasW-`,
	"firstInfoRow": `FundraiserListing_firstInfoRow__OhGpO`,
	"startAt": `FundraiserListing_startAt__4u74N`,
	"endAt": `FundraiserListing_endAt__G+4aM`,
	"secondInfoRow": `FundraiserListing_secondInfoRow__iFreH`,
	"totalDonations": `FundraiserListing_totalDonations__H+m5m`
};
export default ___CSS_LOADER_EXPORT___;
